module.exports = require("rotating-file-stream");